import * as React from 'react'

import { LightbulbIcon } from '@buffer-mono/popcorn'

import { SectionAvatar } from '~publish/components/SectionAvatar'

type CreateAvatarProps = {
  /** Positioning/layout overrides only — the visual is locked to the CSS. */
  className?: string
}

/**
 * The "Create" tile next to the Create page title, visually matched to
 * `AllChannelsAvatar` so the product-header tiles read as one system.
 */
const CreateAvatar = React.forwardRef<HTMLDivElement, CreateAvatarProps>(
  ({ className }, forwardedRef) => {
    return (
      <SectionAvatar ref={forwardedRef} className={className}>
        <LightbulbIcon size={24} />
      </SectionAvatar>
    )
  },
)

CreateAvatar.displayName = 'CreateAvatar'

export { CreateAvatar }
export type { CreateAvatarProps }
